/* eslint-disable @reatom/unit-naming-rule */
import {
  tradingPairAddressAtom,
  tradingPairAtom,
  tradingWalletAtom,
} from '@root/features/trade/trading/atoms'

import { reatomControlsCommon } from '../reatom-controls-common'

import { reatomLimitSellControls } from './reatom-limit-sell-controls'
import { reatomMarketSellControls } from './reatom-market-sell-controls'

export const reatomSellControls = () => {
  const marketModel = reatomMarketSellControls({
    pairAtom: tradingPairAtom,
    walletAtom: tradingWalletAtom,
  })
  const limitModel = reatomLimitSellControls({
    sellAmountCurrencyAtom: marketModel.inputModel.amountAtom,
  })
  reatomControlsCommon({
    pairAddressAtom: tradingPairAddressAtom,
    quoteModel: marketModel.quoteModel,
  })

  return {
    ...marketModel,
    receiveAmountNativeAtom: marketModel.receiveAmountNativeAtom,
    limitModel,
  }
}

export type SellControlsModel = ReturnType<typeof reatomSellControls>
